import { useEffect } from "react";
import { useNavigate } from "react-router"
import icon from "../assets/images/icon-check.png"

function EmailSent() {
    let navigate = useNavigate();

    useEffect(() => {
        // Change background color
        document.body.style.backgroundColor = "#f8f9fe"
    }, [])

    
    return (
        <div>
            <div className="login">
                <div className="login-form" style={{textAlign: 'center'}}>
                    <img src={icon} alt="icon" />
                    <div style={{textAlign: 'center', fontFamily: 'VinciBold', fontSize: '18px'}}>
                        Un e-mail vient de vous être envoyé pour réinitialiser votre mot de passe
                    </div>
                    <div>
                        <button className="button" onClick={() => navigate("/")}>Connexion</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmailSent;